// extracted by mini-css-extract-plugin
export default {"line":"HorizontalLine_line__SDD-4"};